import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

/**
 * A React hook that automatically clears all toast notifications
 * when navigating between routes in the application.
 *
 * Usage:
 * Import this hook in your App.js or layout component and call it:
 * ```
 * function MyComponent() {
 *   useClearToastsOnRouteChange();
 *   // rest of component...
 * }
 * ```
 */
export const useClearToastsOnRouteChange = () => {
    const location = useLocation();

    useEffect(() => {
        // Clear all toasts when the route changes
        toast.dismiss();
    }, [location.pathname]);

    return null;
};

export default useClearToastsOnRouteChange;
